"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const R = __importStar(require("ramda"));
const react_final_form_1 = require("react-final-form");
const validate_1 = __importDefault(require("@8base/validate"));
const utils_1 = require("@8base/utils");
const FormContext_1 = require("./FormContext");
const utils_2 = require("./utils");
// @ts-ignore
const hackMultiple = component => (_a) => {
    var { tempMultiple } = _a, props = __rest(_a, ["tempMultiple"]);
    return react_1.default.createElement(component, Object.assign(Object.assign({}, props), { multiple: tempMultiple }));
};
/**
 * `Field` wrapper based on `Field` from the [`react-final-form`](https://github.com/final-form/react-final-form). That accept [`FieldProps`](https://github.com/final-form/react-final-form#fieldprops) props.
 */
const Field = (props) => {
    const { tableSchema } = react_1.useContext(FormContext_1.FormContext);
    if (tableSchema) {
        const fieldSchema = utils_1.tableSelectors.getFieldByName(tableSchema, utils_2.getFieldSchemaName(props.name));
        if (fieldSchema) {
            const fieldValidate = validate_1.default(fieldSchema);
            // Combine validation functions if needed
            if (typeof props.validate === 'function') {
                const { validate } = props;
                // @ts-ignore
                props = R.assoc('validate', (...args) => validate(...args, fieldValidate), props);
            }
            else {
                props = R.assoc('validate', fieldValidate, props);
            }
            // Provide field schema to non basic fields
            if (!R.propIs(String, 'component', props)) {
                props = R.assoc('fieldSchema', fieldSchema, props);
            }
        }
    }
    // Temp fix, waiting for update https://github.com/final-form/react-final-form/releases/tag/v6.3.1
    if (typeof props.component === 'function' && props.multiple) {
        props = R.assoc('tempMultiple', props.multiple, props);
        props = R.assoc('component', hackMultiple(props.component), props);
    }
    return react_1.default.createElement(react_final_form_1.Field, Object.assign({}, props));
};
exports.Field = Field;
//# sourceMappingURL=Field.js.map